import { createAxiosHttpClient } from '@/shared/features/query/infra/adapters/axios.adapter';

/**
 * Application service for newsletter-related operations.
 * Uses the shared HttpClientForQuery adapter (Axios) to call backend APIs.
 */
export async function subscribeToNewsletter(email: string): Promise<void> {
  const httpClient = createAxiosHttpClient();

  await httpClient.request<void>({
    url: '/newsletter/subscribe',
    method: 'POST',
    data: { email },
  });
}

